import script from "./Indicator.vue?vue&type=script&setup=true&lang=js"
export * from "./Indicator.vue?vue&type=script&setup=true&lang=js"

import "./Indicator.vue?vue&type=style&index=0&id=672eca63&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/www/releases/20260911022515/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-672eca63"]])

export default __exports__